<template>
  <el-dialog @open="iniciar" title="Adicionar Link Útil" :visible.sync="visibility" :before-close="cancelar" :close-on-click-modal="false" :modal-append-to-body="false" width="400px">
    <el-form label-position="top" size="small">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Nome">
            <el-input v-model="linkUtil.nome" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="URL">
            <el-input v-model="linkUtil.endereco" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    
    <span slot="footer">
      <el-button @click="clickBotaoAdicionar" size="mini" type="success">
        Adicionar
      </el-button>
      <el-button @click="clickBotaoFechar" size="mini" type="danger">
        Fechar
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
const baseLinkUtil = {
  nome: '',
  endereco: '',
};

export default {
  props: {
    visibility: Boolean,
  },

  data() {
    return {
      linkUtil: { ...baseLinkUtil },
    };
  },

  methods: {
    clickBotaoAdicionar() {
      if(!this.linkUtil.nome.trim() || !this.linkUtil.endereco.trim()) {
        return;
      }

      const nome = this.linkUtil.nome;
      const endereco = this.linkUtil.endereco;

      this.adicionarLinkUtil({ nome, endereco });
    },

    adicionarLinkUtil({ nome, endereco }) {
      this.$emit('adicionar', { nome, endereco });
    },

    clickBotaoFechar() {
      this.close();
    },

    iniciar() {
      this.reset();
    },

    reset() {
      this.resetFormLinkUtil();
    },

    resetFormLinkUtil() {
      this.linkUtil = { ...baseLinkUtil };
    },

    cancelar() {
      this.close();
    },

    close() {
      this.$emit('close');
    },
  },
}
</script>

<style>

</style>